import React from 'react';
import { Form, Button, Input, Col, Row, InputNumber, message } from 'antd';
import ModalDom from '../../../../components/Modal';
import DetailTitle from '../../../../components/DetailTitle/index';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { postFrom, config } from '../../../../axios';
import moment from 'moment';
import ActionRecords from '../../../ActionRecords/index';
import { backMoneyType } from '../../../../axios/dictionaries';
import { moneyAddComma } from '../../../../utils'

class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            actionVisible: false,
            data: {},
        }
    }


    componentDidMount() {
        this.props.onRef(this)
    }

    loadPackage = (id) => {
        this.setState({ loading: true });
        let data = { billId: id };
        postFrom({
            url: config.API_bill_getBillById,
            data,
        }).then(res => {
            this.setState({ data: res, loading: false });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        })
    }

    render() {
        let { visible, handleCancel } = this.props;
        let {
            loading,
            data,
            actionVisible
        } = this.state;

        let endPayTypes = backMoneyType.find(item => item.value === data.payStatus);
        let payTypes = backMoneyType.find(item => item.value === data.offlinePayType);

        return <ModalDom
            title="退款详情 【账单】"
            visible={visible}
            loading={loading}
            onCancel={handleCancel}
            footer={
                <Button onClick={handleCancel}>关闭</Button>
            }
            actionRecords={true}
            handleAction={() => {
                this.setState({ actionVisible: true });
                this.onAction.queryActionRecords({ rowId: data.id, tableName: "bill" });
            }}
        >
            <ActionRecords
                onRef={ref => this.onAction = ref}
                visible={actionVisible}
                handleCancel={() => { this.setState({ actionVisible: false }) }}
            />
            <div className="custom">
                <DetailTitle title="房源" boxStyle={{ marginTop: 0 }} />
                <CustomRow>
                    <CustomCol label="楼栋/楼盘" required={false} >
                        <Input
                            disabled={true}
                            value={data.buildingName}
                        />
                    </CustomCol>
                    <CustomCol label="房间号" required={false} >
                        <Input
                            disabled={true}
                            value={data.roomNo}
                        />
                    </CustomCol>
                </CustomRow>
                <DetailTitle title="租客" />
                <CustomRow>
                    <CustomCol label="姓名" required={false} >
                        <Input
                            disabled={true}
                            value={data.customerName}
                        />
                    </CustomCol>
                    <CustomCol label="证件号码" required={false} >
                        <Input
                            disabled={true}
                            value={data.credentialNumber}
                        />
                    </CustomCol>
                    <CustomCol label="手机号码" required={false} >
                        <Input
                            disabled={true}
                            value={data.customerPhone}
                        />
                    </CustomCol>
                </CustomRow>
                <DetailTitle title="应退" />
                <CustomRow>
                    <CustomCol label="应退金额" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>} >
                        <InputNumber
                            disabled={true}
                            value={data.billMoney}
                        />
                    </CustomCol>
                    <CustomCol label="退款原因" required={false} >
                        <Input
                            disabled={true}
                            value={data.feeRemark}
                        />
                    </CustomCol>
                </CustomRow>
                <CustomRow divider>
                    <CustomCol label="应退方式" required={false} >
                        <Input
                            disabled={true}
                            value={endPayTypes ? endPayTypes.title : ''}
                        />
                    </CustomCol>
                    <CustomCol label="账号信息" colStyle={{ width: "501px" }} required={false} >
                        <Input
                            disabled={true}
                            value={data.endPayAccount}
                        />
                    </CustomCol>
                </CustomRow>
                <DetailTitle title="实退" />
                <CustomRow>
                    <CustomCol label="退款方式" required={false} >
                        <Input
                            disabled={true}
                            value={payTypes ? payTypes.title : ""}
                        />
                    </CustomCol>
                    <CustomCol label="退款日期" required={false} >
                        <Input
                            disabled={true}
                            value={data.offlinePayDate ? moment(data.offlinePayDate).format("YYYY-MM-DD") : ""}
                        />
                    </CustomCol>
                    <CustomCol label="退款金额" required={false} >
                        <Input
                            disabled={true}
                            value={ data.offlinePayAmount }
                        />
                    </CustomCol>
                </CustomRow>
                <CustomRow divider>
                    <CustomCol label="退款流水" required={false} >
                        <Input
                            disabled={true}
                            value={data.offlineOrderNoThird}
                        />
                    </CustomCol>
                    <CustomCol label="退款说明" colStyle={{ width: "501px" }} required={false} >
                        <Input
                            disabled={true}
                            value={data.offlinePayRemark}
                        />
                    </CustomCol>
                </CustomRow>
                <div>
                    <DetailTitle title="转入" />
                    <div className="tableBox">
                        <div className="tableTitle">
                            <div style={{ flex: 1 }}>应收日期</div>
                            <div style={{ flex: 1 }}>房源</div>
                            <div style={{ flex: 1 }}>账单名称</div>
                            <div style={{ flex: 1 }}>账单周期</div>
                            <div style={{ flex: 1 }}>应收金额（元）</div>
                            <div style={{ flex: 1 }}>核销日期</div>
                            <div style={{ flex: 1 }}>核销金额（元）</div>
                        </div>
                        <div className="tableBody">
                            {
                                data.payTradeRecordList instanceof Array && data.payTradeRecordList.length > 0 ?
                                    data.payTradeRecordList.map((item, index) => {
                                        return (
                                            <div className="tableBodyRow" key={index}>
                                                <div style={{ flex: 1 }}>{item.mustPayDate ? moment(item.mustPayDate).format('YYYY-MM-DD') : null}</div>
                                                <div style={{ flex: 1, flexDirection: "column" }}>
                                                    <div>
                                                        {item.roomNo ? item.roomNo : null}
                                                    </div>
                                                    <div>
                                                        {item.buildingName ? item.buildingName : null}
                                                    </div>
                                                </div>
                                                <div style={{ flex: 1 }}>{item.billFeeName ? item.billFeeName : null}</div>
                                                <div style={{ flex: 1, flexDirection: "column" }}>
                                                    <div>
                                                        {item.billBeginDate ? moment(item.billBeginDate).format('YYYY-MM-DD') : null}
                                                    </div>
                                                    <div>
                                                        {item.billEndDate ? moment(item.billEndDate).format('YYYY-MM-DD') : null}
                                                    </div>
                                                </div>
                                                <div style={{ flex: 1 }}>{moneyAddComma(item.billMoney)}</div>
                                                <div style={{ flex: 1 }}>{item.payLogCreateTime ? moment(item.payLogCreateTime).format('YYYY-MM-DD') : null}</div>
                                                <div style={{ flex: 1, color: "red" }}> {moneyAddComma(item.payLogAmount)}</div>
                                            </div>
                                        )
                                    })
                                    : <div className="tableBodyRow" style={{ height: '34px', lineHeight: '34px', justifyContent: 'center', color: '#888' }}>暂无数据！</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </ModalDom>
    }


}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Bill/components/Payment/Detail.js